import { ReactNode, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { NOTE_HEADER_ACTIONS_ID } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/contant/encounter-constant";

export interface HeaderActionPortalProps {
  children: ReactNode;
  /** Element id inside the visit-information header to render into. */
  targetId?: string;
}

/** Renders its children in the visit-information header; stays inline when that slot is not on the page. */
const HeaderActionPortal = ({
  children,
  targetId = NOTE_HEADER_ACTIONS_ID,
}: HeaderActionPortalProps) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setTarget(document.getElementById(targetId));
  }, [targetId]);

  return target ? createPortal(children, target) : <>{children}</>;
};

export default HeaderActionPortal;
